import { render, staticRenderFns } from "./hero.vue?vue&type=template&id=014d4d52&scoped=true&"
import script from "./hero.vue?vue&type=script&lang=js&"
export * from "./hero.vue?vue&type=script&lang=js&"
import style0 from "./hero.vue?vue&type=style&index=0&id=014d4d52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014d4d52",
  null
  
)

export default component.exports